import axiosInstance from "../api/axiosInstance";


export const fetchChatMessages = async ({
  uid,
  otherUser,
  limit = 20,
  cursor,      // changed from page
  search,
}) => {
  const params = new URLSearchParams();
  if (otherUser) params.append("otherUser", otherUser);
  params.append("limit", limit);
  if (cursor) params.append("cursor", cursor);
  if (search) params.append("searchKey", search);

  const res = await axiosInstance.get(`/admin/chat/messages/${uid}?${params.toString()}`);
  return res.data;
};
